import { supabase } from '@/lib/supabase';

const toMessage = (row) => ({
  id: row.id,
  companyId: row.company_id,
  opportunityId: row.opportunity_id,
  senderCompanyId: row.sender_company_id,
  senderName: row.sender_name,
  senderEmail: row.sender_email,
  senderWhatsapp: row.sender_whatsapp,
  body: row.body,
  readAt: row.read_at,
  createdAt: row.created_at,
});

export const messageService = {
  async send({ companyId, opportunityId, senderUserId, senderCompanyId, senderName, senderEmail, senderWhatsapp, body }) {
    const { error } = await supabase.from('messages').insert({
      company_id: companyId,
      opportunity_id: opportunityId || null,
      sender_user_id: senderUserId,
      sender_company_id: senderCompanyId,
      sender_name: senderName,
      sender_email: senderEmail,
      sender_whatsapp: senderWhatsapp || null,
      body,
    });
    if (error) throw new Error(error.message);
  },

  /** Mensagens recebidas pela empresa, da mais nova para a mais antiga. */
  async inbox(companyId) {
    const { data, error } = await supabase
      .from('messages')
      .select('*')
      .eq('company_id', companyId)
      .order('created_at', { ascending: false });
    if (error) throw new Error(error.message);
    return (data || []).map(toMessage);
  },

  async markRead(id) {
    const { error } = await supabase
      .from('messages')
      .update({ read_at: new Date().toISOString() })
      .eq('id', id);
    if (error) throw new Error(error.message);
  },

  async remove(id) {
    const { error } = await supabase.from('messages').delete().eq('id', id);
    if (error) throw new Error(error.message);
  },
};